import TextPressure from "./TextPressure";

function Services() {
  return (
    <section id="services" className="services">
      <div className="container">
        <h1 className="section-heading">
        <span>
          <TextPressure text="Our " textColor="#000000" />
        </span>
          <TextPressure text="Skills" textColor="#00d9ff" />
        </h1>
        <p>We provide high standar clean website for your business solutions</p>

        <div className="card-wrapper">

          <div className="card">
            <img src="/images/Lang.png" alt="" />
            <h2>Language</h2>
            <p>* C</p>
            <p>* C++</p>
            <p>* SQL</p>
            <p>* Java</p>
            <p>* Python</p>
            <p>* JavaScript</p>
          </div>

          <div className="card">
            <img src="/images/web.png" alt="" />
            <h2>Web Technologies</h2>
            <p>* CSS3</p>
            <p>* HTML5</p>
            <p>* Node.js</p>
            <p>* React.js</p>
            <p>* Express.js</p>
            <p>* JavaScript</p>
          </div>

          <div className="card">
            <img src="/images/bag.png" alt="" />
            <h2>Database</h2>
            <p>* SQLite</p>
            <p>* MySQL</p>
            <p>* Firebase</p>
            <p>* MongoDB</p>
          </div>

          <div className="card">
            <img src="/images/tools.png" alt="" />
            <h2>Tools & Platforms</h2>
            <p>* Canva</p>
            <p>* IntelliJ</p>
            <p>* GitHub</p>
            <p>* VS Code</p>
            <p>* Arduino IDE</p>
            <p>* Jupyter Notebook</p>
          </div>

          <div className="card">
            <img src="/images/media.png" alt="" />
            <h2>Concepts / CS Fundamentals</h2>
            <p>* DBMS</p>
            <p>* Operating Systems</p>
            <p>* Computer Networks</p>
            <p>* Data Structures and Algorithms</p>
            <p>* Software Development Life Cycle</p>
            <p>* Object-Oriented Programming (OOPs)</p>
          </div>

          <div className="card">
            <img src="/images/domain.png" alt="" />
            <h2>Additional Domains</h2>
            <p>* Cloud</p>
            <p>* AI/ML Basics</p>
            <p>* Cybersecurity Basics</p>
            <p>* Internet of Things (IoT)</p>        
            <p>* Mobile App Development</p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Services;
